import {getActiveFiltersWithValues} from './active-filters';
import clonedeep from 'lodash.clonedeep';

export function parseQueryString(queryString, filters, pageNum = 0) {
    // Default (empty) object of possible filters
    let obj = {
        activeFilters: clonedeep(filters),
        currentPage: pageNum,
        invalid: {
            isInvalid: false,
            value: ''
        }
    };

    // Return default object if query string is not set
    if (!queryString) { return obj; }

    // Create a function to create invalid notice object
    const _setInvalid = (key, value) => {
        return {
            isInvalid: true,
            value: `${obj.invalid.value}${key}=${value}`
        };
    };

    // Map the variables to an object
    let variables = queryString.split('&');
    variables.map(variable => {
        let arr = variable.split('=');
        let key = arr[0];
        let options = arr[1].split(',');

        // Only parse the string if we have options
        if (!options.length || !options[0]) { return; }

        if (key === 'sortBy') {
            // Simple single value options
            obj[key] = decodeURIComponent(options[0]);

        } else if (key === 'currentPage') {

            if (/\d$/gi.test(options[0])) {
                // If we have only digits
                obj[key] = options[0];
            } else {
                // Otherwise, it's an invalid query
                obj.invalid = _setInvalid(key, options[0] + 1);
            }

        } else {
            // Parse active filters
            const currentFilters = decodeURIComponent(options[0]).split('+');

            for(let filter of obj.activeFilters) {
                if (filter.queryParam === key) {
                    for (let current of currentFilters) {
                        if (current === 'true') {
                            filter.values.push(true);
                        } else if (current === 'false') {
                            filter.values.push(false);
                        } else {
                            filter.values.push(current);
                        }
                    }
                    break;
                }
            }

        }
    });

    return obj;
}

// Build the query string from the object provided
export function buildQueryString(value) {
    // If we're passed null we assume filters are being cleared
    if (!value) { return ''; }

    // Map the value from a complicated object
    let filterString = [];
    Object.keys(value).map(key => {

        // Handle the selectedFilters key differently to nomal values (just like in parseQueryString())
        if (key === 'activeFilters') {
            let selectedFilters = getActiveFiltersWithValues(value.activeFilters);

            for(let filter of selectedFilters) {
                const opts = filter.values.map(opt => {
                    return encodeURIComponent(opt);
                });

                filterString.push(`${filter.queryParam}=${opts.join('+')}`);
            }

        } else if ((key === 'sortBy' && value[key] !== 'default')) {
            filterString.push(`${key}=${encodeURIComponent(value[key])}`);

        } else if (key === 'currentPage' && value[key] !== 0) {
            filterString.push(`${key}=${value[key]}`);
        }
    });

    const queryString = filterString.length ? `?${filterString.join('&')}` : '';
    return queryString;
}



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/utils/query-string.js
 **/